module.exports = __webpack_public_path__ + "img/bg.fdeffd2e.png";